import { EveRoutes } from '@ver-uds/e-verify';
import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import InternalLinks from '../../constants/InternalLinks';

export interface MainRouteProps extends RouteProps {
  path: string | string[];
  exact?: boolean;
  conditionToShow?: boolean;
  showTutorial?: boolean;
  showEvePlusAttestation?: boolean;
}
const MainRoute = ({
  path,
  exact,
  conditionToShow,
  showTutorial,
  showEvePlusAttestation,
  children,
}: MainRouteProps): JSX.Element => {
  return (
    <Route
      path={path}
      exact={exact}
      render={(): React.ReactNode => {
        // Redirect to tutorial
        if (showTutorial) {
          return <Redirect to={EveRoutes.TUTORIAL} />;
        }

        // Redirect to eve+ training
        if (showEvePlusAttestation && path !== EveRoutes.I9_TRAINING && path !== EveRoutes.EVERIFY_PLUS_TOS) {
          return <Redirect to={EveRoutes.I9_TRAINING} />;
        }

        // For private routes
        if (!conditionToShow) {
          return <Redirect to={InternalLinks.PAGE_NOT_FOUND} />;
        }

        // Show route
        return React.isValidElement(children) && children;
      }}
    />
  );
};

MainRoute.defaultProps = { exact: false, conditionToShow: true, showTutorial: false, showEvePlusAttestation: false };

export default MainRoute;
